import {Box} from '@mui/material';
import {FormProvider} from 'react-hook-form';

import useReportParameters from '../../../../hooks/providers/useReportParameters';
import {useParametersForm} from '../form/useParametersForm';
import ParametersActions from '../ParametersActions/ParametersActions';
import ParametersHeader from '../ParametersHeader/ParametersHeader';
import SingleParameterRow from '../SingleParametersRow/SingleParameterRow';

const ParametersList = () => {
  const {currentReport, updateDatasetParameters} = useReportParameters();
  const parameters = currentReport?.parameters || [];

  const {methods, formState, handleCancel, handleSubmitForm} = useParametersForm(parameters, updateDatasetParameters);

  return (
    <FormProvider {...methods}>
      <Box sx={{px: 0.5, py: 1}}>
        <ParametersHeader />

        {parameters.map(param => (
          <SingleParameterRow key={param.name} param={param} />
        ))}

        <ParametersActions formState={formState} onCancel={handleCancel} onSave={handleSubmitForm} />
      </Box>
    </FormProvider>
  );
};

export default ParametersList;
